module.exports = __webpack_public_path__ + "static/media/logo.a73c1d31.png";